<template>
  <!-- 主页面布局 -->
  <el-container>
    <!-- 侧边菜单栏 -->
    <el-aside :class="{uncollapse: !isCollapse}" :style="{ width: isCollapse ? '60px' : '180px' }">
      <div class="nav-header">
        <img v-if="isCollapse" src="/static/imgs/fyzn/logomini.png" alt="ydm_logo"
             style="margin-left: -25px; margin-top: -2px;width:100px; height:66px">
        <img v-else src="/static/imgs/fyzn/logoTop.png" alt=""
             style="margin-left: -37px; margin-top: -26px;width:202px; height:105px">
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        background-color="#242a3c"
        text-color="#fff"
        :collapse-transition="false"
        router
        :collapse="isCollapse"
        active-text-color="#fff">
        <!--<el-menu-item index="/main/ztree/treeDemo">-->
        <!--<i class="fa fa-dashboard"></i>-->
        <!--<span slot="title">ztree</span>-->
        <!--</el-menu-item>-->
        <el-menu-item index="/main" v-if="this.$hasPerm('B003')">
          <i class="fa fa-dashboard"></i>
          <span slot="title">平台总览</span>
        </el-menu-item>
        <el-menu-item index="/main/case/list" v-if="false">
          <i class="fa fa-list"></i>-
          <span slot="title">案件列表</span>
        </el-menu-item>
        <el-menu-item index="/main/case/caseList" v-if="this.$hasPerm('B002')">
          <i class="fa fa-list"></i>
          <span slot="title">案件列表</span>
        </el-menu-item>
        <el-menu-item index="/main/repay/list" v-if="this.$hasPerm('HK001')">
          <i class="fa fa-list"></i>
          <span slot="title">还款列表</span>
        </el-menu-item>
        <el-menu-item index="/main/reply/list" v-if="this.$hasPerm('HK001')">
          <i class="fa fa-list"></i>
          <span slot="title">回复列表</span>
        </el-menu-item>
        <el-menu-item index="/main/batchOverview/list" v-if="this.$hasPerm('PC001')">
          <i class="fa fa-university"></i>
          <span slot="title">批次总览</span>
        </el-menu-item>
        <el-menu-item index="/main/collection/report" v-if="this.$hasPerm('B011')">
          <i class="fa fa-file-text-o"></i>
          <span slot="title">作业报告</span>
        </el-menu-item>
        <el-menu-item index="/main/collection/engine" v-if="this.$hasPerm('B008')">
          <i class="fa fa-cogs"></i>
          <span slot="title">策略引擎</span>
        </el-menu-item>
        <el-menu-item index="/main/collection/settlement" v-if="this.$hasPerm('B035')">
          <i class="fa fa-money"></i>
          <span slot="title">策略结算</span>
        </el-menu-item>
        <el-submenu index="11" v-if="this.$hasPerm('B033')">
          <template slot="title">
            <i class="fa el-icon-guide"></i>
            <span>条件路由</span>
          </template>
          <el-menu-item index="/main/collection/condition" v-if="this.$hasPerm('B033')">策略组</el-menu-item>
          <el-menu-item index="/main/collection/condition/scene" v-if="this.$hasPerm('B033')">对话场景</el-menu-item>
          <el-menu-item index="/main/collection/condition/template" v-if="this.$hasPerm('B033')">场景模版</el-menu-item>
        </el-submenu>
        <el-menu-item index="/main/collection/intention" v-if="this.$hasPerm('B034')">
          <i class="fa el-icon-setting"></i>
          <span>意图信息</span>
        </el-menu-item>
        <el-menu-item index="/main/decisions/config" v-if="this.$hasPerm('B018')">
          <i class="fa fa-codepen"></i>
          <span slot="title">决策引擎</span>
        </el-menu-item>
        <el-menu-item index="/main/test_engine" v-if="this.$hasPerm('Z003')">
          <i class="fa fa-android"></i>
          <span slot="title">测试引擎</span>
        </el-menu-item>
        <el-menu-item index="/main/company" v-if="this.$hasPerm('B012')">
          <i class="fa fa-building-o"></i>
          <span slot="title">公司信息</span>
        </el-menu-item>
        <el-menu-item index="/main/phoneBlacklist" v-if="this.$hasPerm('H001')">
          <i class="fa fa-black-tie"></i>
          <span slot="title">电话黑名单</span>
        </el-menu-item>
        <el-menu-item index="/main/costCalculation" v-if="this.$hasPerm('Z021')">
          <i class="fa fa-building-o"></i>
          <span slot="title">费用核算</span>
        </el-menu-item>
        <el-menu-item index="/main/account/list" v-if="this.$hasPerm('Z001')">
          <i class="fa fa-users"></i>
          <span slot="title">账号管理</span>
        </el-menu-item>
        <!-- <el-menu-item index="/main/telephone/voice">
          <i class="fa fa-users"></i>
          <span slot="title">录音测试</span>
        </el-menu-item> -->
        <el-menu-item index="/main/permission/list" v-if="this.$hasPerm('Z016')">
          <i class="fa fa-briefcase"></i>
          <span slot="title">权限配置</span>
        </el-menu-item>
        <el-submenu index="systemConfig" v-if="this.$partB()">
          <template slot="title">
            <i class="fa fa-cog"></i>
            <span slot="title">系统配置</span>
          </template>
          <el-menu-item index="/main/job/list">定时任务</el-menu-item>
          <el-menu-item index="/main/dict/listType">字典管理</el-menu-item>
          <el-menu-item index="/main/recorder">录音员配置</el-menu-item>
          <el-menu-item index="/main/system/config">跟进配置(营销)</el-menu-item>
          <el-menu-item index="/main/system/collectConfig">跟进配置(催收)</el-menu-item>
          <el-menu-item index="/main/system/pushRecord">推送记录</el-menu-item>
          <el-menu-item index="/main/system/keywordAudio" v-if="this.$hasPerm('B008&11')">关键字音频</el-menu-item>
        </el-submenu>
        <el-submenu index="10" v-if="this.$hasPerm('Z004') || this.$hasPerm('Z014') || this.$hasPerm('Z022')">
          <template slot="title">
            <i class="fa fa-phone-square"></i>
            <span>呼叫平台</span>
          </template>
          <el-menu-item index="/main/call/default" v-if="this.$hasPerm('Z004')">默认配置</el-menu-item>
          <el-menu-item index="/main/call/custom" v-if="this.$hasPerm('Z014')">自定义配置</el-menu-item>
          <el-menu-item index="/main/call/service" v-if="this.$hasPerm('Z022')">服务配置</el-menu-item>
          <el-menu-item index="/main/call/serviceBox" v-if="this.$hasPerm('Z022')">资源组维护</el-menu-item>
          <el-menu-item index="/main/call/sbcGroup" v-if="this.$hasPerm('Z022')">SBC资源组</el-menu-item>
        </el-submenu>
        <el-menu-item index="/main/message/list" v-if="this.$partB()">
          <i class="fa fa-send-o"></i>
          <span slot="title">案件触发</span>
        </el-menu-item>
        <el-submenu index="algCorpus"
                    v-if="this.$hasPerm('Z002') || this.$hasPerm('Z008') || this.$hasPerm('Z009') || this.$hasPerm('Z010') || this.$hasPerm('B026') || this.$hasPerm('Z013')">
          <template slot="title">
            <i class="fa fa-audio-description"></i>
            <span>语料管理</span>
          </template>
          <el-menu-item index="/main/algCorpus/robotMarkLabel" v-if="this.$hasPerm('Z002')">打标页面</el-menu-item>
          <el-menu-item index="/main/algCorpus/robotKeyWord" v-if="this.$hasPerm('Z008')">关键词表</el-menu-item>
          <el-menu-item index="/main/algCorpus/robotInteractiveQuery" v-if="this.$hasPerm('Z009')">交互查询
          </el-menu-item>
          <el-menu-item index="/main/algCorpus/robotMarkLabelAssignment" v-if="this.$hasPerm('Z010')">打标分配
          </el-menu-item>
          <!-- <el-menu-item index="12-5" v-if="this.$hasPerm('B026')">语音听写</el-menu-item>
          <el-menu-item index="12-6" v-if="this.$hasPerm('Z013')">听写查询</el-menu-item> -->
          <el-menu-item index="/main/algCorpus/robotLuceneSetting" v-if="this.$hasPerm('Z020')">敏感词管理
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/main/fileProcess" v-if="this.$hasPerm('F001')">
          <i class="fa fa-briefcase"></i>
          <span slot="title">文件处理</span>
        </el-menu-item>
        <el-submenu index="13" v-if="this.$hasPerm('Z007')">
          <template slot="title">
            <i class="fa fa-bullseye"></i>
            <span>系统监控</span>
          </template>
          <el-menu-item index="" @click="openMonitor">实时监控</el-menu-item>
          <el-menu-item index="/main/monitor/robotAlarmSetting">报警设置</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <!-- 主容器区域 -->
    <el-main>
      <el-container>
        <!-- 主容器头部 -->
        <el-header>
          <!-- 左侧菜单的展开/关闭按钮 -->
          <a href="javascript: void(0);" class="menu-collapse" @click="isCollapse = !isCollapse">
            <svg v-if="isCollapse" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-icon="menu-unfold"
                 width="30" height="30" fill="currentColor" aria-hidden="true">
              <path
                d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519c4.5-3.5 4.5-10.3 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3c0 7.4 8.5 11.6 14.4 7z"></path>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-icon="menu-fold" width="30"
                 height="30" fill="currentColor" aria-hidden="true">
              <path
                d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1c-4.5 3.5-4.5 10.3 0 13.8z"></path>
            </svg>
          </a>
          <div class="header-options">
            <div class="current-time" v-if="this.$hasPerm('B036')">{{ currentTime }}</div>
            <el-button class="upload-case" icon="el-icon-upload" plain size="small"
                       @click="importCase();getGroupList();getCompanyInfo();" v-if="this.$hasPerm('B016')">案件导入
            </el-button>
            <div class="search-wrapper">
              <el-dropdown @command="searchChange" size="medium">
                <span class="white">
                  {{ caseSearchBody.label }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="aCaseId,进件号"> 进件号</el-dropdown-item>
                  <el-dropdown-item command="mobile,手机号"> 手机号</el-dropdown-item>
                  <el-dropdown-item command="name,姓名"> 姓 名</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <input type="text" class="search-input" v-model="caseSearchBody.keyStr" @keyup.enter="caseSearch"/>
              <i class="el-icon-search icon-btn" @click="caseSearch"></i>
            </div>
            <div v-show="false">
              <span style="font-size: 20px; font-weight: 600;">沧海呼叫中心</span>
              <table
                style="border:1px solid #c4dff6;background-color:#ecf2f7; margin-left: auto; margin-right: auto;margin-top: 50px;">
                <tr>
                  <td>
                    <el-button id="register" class="register"></el-button>
                  </td>
                  <td>
                    <button id="unregister" class="unregister" style="display: none;"></button>
                  </td>
                  <td><input type="text" name="tel_num" id="tel_num" style="width:150px"></td>
                  <td>
                    <button id="makecall" class="makecall"></button>
                  </td>
                  <td>
                    <button id="answer" class="answer"></button>
                  </td>
                  <td>
                    <button id="hangup" class="hangup"></button>
                  </td>
                  <td>
                    <button id="hold" class="hold"></button>
                  </td>
                  <td>
                    <button id="unhold" class="unhold" style="display: none;"></button>
                  </td>
                  <td>
                    <div style="margin-left: 5px">
                      <div style="margin:0 auto"><label class="label-title">电话状态</label></div>
                      <div style="margin:0 auto"><label class="label-content" id="callstate">未登录</label></div>
                    </div>
                  </td>

                  <td>
                    <div style="margin-left: 5px">
                      <div style="margin:0 auto"><label class="label-title">时长</label></div>
                      <div style="margin:0 auto"><label class="label-content" id="calltime">00:00:00</label></div>
                    </div>
                  </td>

                  <td>
                    <div style="margin-left: 5px">
                      <div style="margin:0 auto"><label class="label-title">坐席号码</label></div>
                      <div style="margin:0 auto"><label class="label-content" id="agentnumber">&nbsp;&nbsp;</label>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div style="margin-left: 5px">
                      <div style="margin:0 auto"><label class="label-title">客户号码</label></div>
                      <div style="margin:0 auto"><label class="label-content" id="callnumber">&nbsp;&nbsp;</label></div>
                    </div>
                  </td>
                </tr>
              </table>
              <audio id="remoteAudio"></audio>
              <audio src="/static/guns/sources/ring.wav" loop id="ringAudio"></audio>
              <audio src="/static/guns/sources/hangup.wav" id="hangupAudio"></audio>
            </div>
            <div>
              <el-dropdown v-if="this.$hasPerm('JK001')" trigger="click">
                <span class="text white">
                  <i class="fa el-icon-document"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a href="/static/api/api.html" style="text-decoration:none;" target="_blank">
                    <el-dropdown-item style="color:#4D7CFE;">
                      <i class="el-icon-download"></i> 接口文档
                    </el-dropdown-item>
                  </a>
                  <!--<a href="/static/document/云电猫用户手册_V1.1(20180313).docx" style="text-decoration:none;" target="_blank">-->
                  <!--<el-dropdown-item style="color:#4D7CFE;">-->
                  <!--<i class="el-icon-download"></i> 2. 用户手册_V1.1(20180313)-->
                  <!--</el-dropdown-item>-->
                  <!--</a>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="internationalVersionFlag === '1'">
              <el-dropdown @command="handleLanguageChange">
                <span class="text">
                  <i class="fa fa-language" style="color: #4D7CFE;"></i> <span
                  style="color: #4D7CFE;">{{ getLanguageName(currentLanguage) }}</span> <i
                  class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="lang in languageSelectOptions" :key="lang.modelCode"
                                    :command="lang.modelCode" style="color: #4D7CFE;">
                    {{ lang.modelName }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-dropdown>
                <span class="text">
                  <img src="/static/imgs/default_avatar.png" alt="" class="avatar">
                  {{ this.$account().name }} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="$router.push({ path: '/main/userCenter'});"><i
                    class="fa fa-user-o"></i>个人信息
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="logout" v-loading.fullscreen.lock="loading"><i
                    class="fa fa-sign-out"></i> 退出
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <!-- 主内容 -->
        <el-main class="main-container">
          <transition name="component-fade" mode="out-in">
            <router-view/>
          </transition>
        </el-main>
      </el-container>
    </el-main>
    <el-dialog
      title="导入案件"
      width="50%"
      center
      :visible.sync="importDialogVisible">
      <el-form label-width="180px">
        <el-form-item label="文件上传" @click="removeExcel">
          <input-excel
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :auto-upload="false"
            :on-exceed="handleExceed"
            :file-list="fileList"
            @getResultOfSheet="getMyExcelDataInfo"
          >
            <el-button size="small" type="primary" @click="removeExcel">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请上传模版的Excel</div>
          </input-excel>
          <ul class="el-upload-list el-upload-list--text">
            <li v-if="isSelectExcel" tabindex="0" class="el-upload-list__item is-ready">
              <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ this.upLoadRemindMsg }}</a>
              <label class="el-upload-list__item-status-label"><i
                class="el-icon-upload-success el-icon-circle-check"></i></label>
              <i class="el-icon-close" @click="removeExcel"></i>
            </li>
            <li v-if="readExcelProgressBar" tabindex="0" class="el-upload-list__item is-ready">
              <progress-bar1 @callback="closeProBar1"></progress-bar1>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="导入同步更新">
          <el-switch v-model="cas.importUpdate" :active-value="1" :inactive-value="0"/>
        </el-form-item>
        <!-- <el-form-item label="作业设置">
          <el-radio-group v-model="cas.collectionSetting" @change="getTemplateList">
            <el-radio label="msg">短信</el-radio>
            <el-radio label="v&m">短信加语音</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="作业天数">
          <el-input style="width:30%" v-model="days" controls-position="right" placeholder="最大为30天"
                    @keyup.native="numberDays"></el-input>&nbsp; 天，至
          <el-input v-model="cas.dateInfo" style="width: 150px;" disabled></el-input>
        </el-form-item>
        <el-form-item label="最高减免" v-show="false">
          <el-input style="width:30%" v-model="cas.discount" @keyup.native="numberDisCount" controls-position="right"
                    placeholder="最大为100"></el-input>&nbsp; %
        </el-form-item>
        <el-form-item label="策略组">
          <el-select v-model="cas.group" placeholder="请选择策略组" @change="getTemplateList">
            <el-option
              v-for="item in groupList"
              :key="item.value"
              :label="item.groupName"
              :value="item.id + '&&' + item.isMain + '&&' + item.sendWay + '&&' + item.sendTemplateId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作业对象" v-if="this.$collectible()">
          <el-checkbox-group v-model="cas.target">
            <el-checkbox label="本人" disabled>本人</el-checkbox>
            <el-checkbox label="直系">直系</el-checkbox>
            <el-checkbox label="非直系">非直系</el-checkbox>
            <el-checkbox label="失联修复">失联修复</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否立即发送给本人">
          <el-switch
            v-model="cas.notice">
          </el-switch>&#12288;
          <el-select style="width:120px;" v-model="templateType" @change="templateTypeChange">
            <el-option label="短信" value="msg"></el-option>
            <el-option label="语音" value="ivr"></el-option>
            <!-- <el-option label="智能语音" value="ivoice"></el-option> -->
            <el-option label="场景语音" value="svoice"></el-option>
          </el-select>
          <el-select v-model="cas.sendTemplate" filterable style="position:relative;left:-1%">
            <el-option
              v-for="item in templateList"
              :key="item.value"
              :label="item.name"
              :value="item.content+'&&'+item.id+'&&'+item.type">
              <template>
                <el-tooltip placement="top" effect="light">
                  <div slot="content" v-html="item.contentShow ? item.contentShow : item.content"></div>
                  <span>{{ item.name }}</span>
                </el-tooltip>
              </template>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button icon="el-icon-download" size="small">
          <a href="/static/template/caseImportTemplate.xlsx" download style="color: inherit; text-decoration: none;">
            模板下载</a>
        </el-button>
        <el-button type="primary" @click="newUploadData" size="small">提交数据</el-button>
      </div>
    </el-dialog>
    <div>
      <loading ref="loading" v-if="isLoading" @loadFinish="loadFinish" @closeLoading="removeExcel">上传中。。。。</loading>
    </div>
    <div>
      <copy-temp ref="copyTemp"></copy-temp>
    </div>
  </el-container>
</template>
<script>
import inputExcel from './import/inputExcel';

import progressBar1 from './import/progressBar';

import loading from './import/loading';

import copyTemp from './import/copyTemp';

import Watermark from '../../../static/plugins/watermark/watermark';

const Base64 = require('js-base64').Base64;

export default {
  inject: ['reload'],
  data() {
    return {
      isCollapse: false,
      activeMenu: this.$route.path,
      importDialogVisible: false,
      cas: {
        collectionSetting: 'v&m',
        discount: '',
        group: [],
        target: ['本人'],
        notice: false,
        sendTemplate: '',
        dateInfo: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate() + 1}`,
        importUpdate: 0
      },
      select: '',
      input3: '',
      fileList: [],
      radio: '1',
      agreements: '',
      groupList: [],
      checkboxGroup1: [],
      checked: false,
      templateList: [],
      loading: false,
      days: '',
      languageSelectOptions: [],
      currentLanguage: '0',
      internationalVersionFlag: '0',
      caseSearchBody: {
        label: '进件号',
        page: 1,
        limit: 1,
        key: null,
        order: 'aCaseId',
        sort: 'desc',
        keyType: 'aCaseId',
        keyStr: null,
        keys: []
      },
      baseCaseInfo: '',
      contactInfo: '',
      upLoadRemindMsg: '',
      isSelectExcel: false,
      caseCount: 0,
      contactCount: 0,
      fileName: '',
      caseList: [], // 记录格式化后的案件信息
      contactList: [], // 记录格式化后的联系人细信息
      caseBaseInfoList: [],
      token: '',
      batchToken: '',
      batchNo: '',
      serverUrl: '',
      readExcelProgressBar: false, // 读取excel进度条
      isLoading: false,
      loadNum: 0,
      timing: null,
      conTiming: null,
      resultOfImportCase: null,
      caseSheetKeys: '进件号;姓名;年龄;性别;身份证号码;案件地区;户籍地址;公司地址;常住地址;手机号码;贷款机构;放款日期;借款期数;签约金额;放款金额;月还款额;剩余本金;罚滞总额;逾期总额;逾期状态;逾期次数;最近一次还款时间;最近一次还款金额;贷款类型;逾期天数;委托金额;催收类型;' +
        '已还期数;账单日;借款产品名称;客户绑定划扣银行卡;客户所属公司;佣金费率（甲方，eg:20即为20%，填写时请不要带%）;起委时间;结委时间;教育程度;入职时间;婚姻状况;职位;工作年限;房产状况;子女状况;家庭电话;公司电话;QQ;微信;邮箱;支付宝;' +
        '短信抬头;参数1;参数2;参数3;参数4;参数5;参数6;参数7;参数8;参数9;参数10;参数11;参数12;参数13;参数14;参数15;参数16;参数17;参数18;参数19;参数20;参数21;参数22;参数23;参数24;参数25;参数26;参数27;参数28;参数29;参数30;',
      contactSheetKeys: '进件号;姓名;类别;手机号码;备注（关系）;来源',
      checkCaseResult: false,
      checkContactResult: false,
      checkContactDate: false,
      contactEntity: null,
      templateType: 'msg',
      currentTime: '',
      serverTime: 0
    };
  },
  watch: {
    $route(route) {
      this.activeMenu = route.path;
    }
  },
  mounted() {
    if (this.$account().companyName.length > 6) {
      Watermark.set(`${this.$account().companyName.substring(0, 4)}...-${this.$account().userName}`);
    } else {
      Watermark.set(`${this.$account().companyName}-${this.$account().userName}`);
    }
    this.install();
    this.registerButton();
    this.initLanguage();
    this.getCurrentTime();
  },
  components: {
    inputExcel, progressBar1, loading, copyTemp
  },
  methods: {
    getCurrentTime() {
      this.$ajax({
        method: 'GET',
        url: '/system/getCurrentTime'
      }).then((res) => {
        this.serverTime = new Date(res.data).getTime();
        this.updateTime();
        setInterval(() => {
          this.serverTime += 1000;
          this.updateTime();
        }, 1000);
      }).catch(() => {
        this.updateTime();
        setInterval(() => {
          this.updateTime();
        }, 1000);
      });
    },
    updateTime() {
      let time = this.serverTime;
      if (time === 0) {
        time = Date.now();
      }
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    initLanguage() {
      let retryCount = 0;
      const maxRetries = 10;
      const retryDelay = 100;

      const checkLanguageOptions = async () => {
        this.languageSelectOptions = this.$getLanguageSelectOptions();
        this.internationalVersionFlag = this.$getInternationalVersionFlag();
        this.currentLanguage = this.$getLanguageSelect();
        if (this.languageSelectOptions.length === 0 && retryCount < maxRetries) {
          retryCount++;
          setTimeout(checkLanguageOptions, retryDelay);
        }
      };

      checkLanguageOptions();
    },
    handleLanguageChange(languageCode) {
      this.currentLanguage = languageCode;
      this.$setLanguageSelect(languageCode);
      window.eventBus.$emit('languageSelectChanged', languageCode);
    },
    getLanguageName(languageCode) {
      const lang = this.languageSelectOptions.find(item => item.modelCode === languageCode);
      return lang ? lang.modelName : '中文';
    },
    // 加载
    install() {
      this.$install();
    },
    // 签入
    registerButton() {
      this.$registerButton();
    },
    // 校验作业天数输入框
    numberDays() {
      this.days = this.days.replace(/[^\\.\d]/g, '');
      this.days = this.days.replace('.', '');
      if (this.days > 30) {
        this.days = 30;
      }
      if (this.days <= 0 && this.days !== '') {
        this.days = 1;
      }
      // 计算作业天数
      if (this.days === null || this.days === '' || this.days === undefined) {
        this.cas.dateInfo = '';
        return;
      }
      const days = this.days;
      const nowDate = new Date();
      nowDate.setTime(nowDate.getTime() + ((days) * 24 * 60 * 60 * 1000));
      const newDate = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}-${nowDate.getDate()}`;
      this.cas.dateInfo = newDate;
    },
    // 校验最高减免输入框
    numberDisCount() {
      this.cas.discount = this.cas.discount.replace(/[^\\.\d]/g, '');
      this.cas.discount = this.cas.discount.replace('.', '');
      if (this.cas.discount > 100) {
        this.cas.discount = 100;
      }
    },
    handleOpen(key, keyPath) {
      console.warn(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.warn(key, keyPath);
    },
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    handlePreview(file) {
      console.warn(file);
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    beforeRemove() {
      this.fileList = [];
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    importCase() {
      this.initUploadInfo();
      this.fileList = [];
      this.cas.collectionSetting = 'v&m';
      this.cas.discount = '';
      this.cas.group = [];
      this.cas.target = ['本人'];
      this.cas.notice = false;
      this.cas.sendTemplate = '';
      this.cas.dateInfo = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate() + 1}`;
      this.days = '';
      this.templateList = [];
      this.importDialogVisible = true;
    },
    importWriteCache(batchNo) {
      const caseSearchBody = {
        page: 1,
        limit: 50,
        order: 'aCaseId',
        sort: 'desc',
        batchNo
      };
      localStorage.removeItem('caseSearchCompanyId');
      localStorage.removeItem('caseSearchCache');
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(caseSearchBody);
      localStorage.setItem('caseSearchCache', caseSearchCache);
    },
    // 获取策略组
    getGroupList() {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUserNew'
      }).then((res) => {
        const aa = { groupName: '不指定', id: '', isMain: '', sendWay: '', sendTemplateId: '' };
        res.data.push(aa);
        this.groupList = res.data;
        this.cas.group = '&&&&&&';
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '获取策略组失败!'
        });
      });
    },
    getCompanyInfo() {
      this.$ajax({
        method: 'GET',
        url: '/company/getCompanyInfo'
      }).then((res) => {
        this.cas.importUpdate = res.data.importUpdate;
      });
    },
    // 获取发送模版
    getTemplateList() {
      if (this.cas.group === '&&&&&&') {
        this.templateList = [];
        this.cas.sendTemplate = '';
        return;
      }
      const groupInfo = this.cas.group.split('&&');
      if (groupInfo[2] === 'ivr') {
        this.templateType = groupInfo[2];
      } else if (groupInfo[2] === 'ivoice') {
        this.templateType = 'ivoice';
      } else if (groupInfo[2] === 'svoice') {
        this.templateType = 'svoice';
      } else {
        this.templateType = 'msg';
      }
      // console.warn(groupInfo);
      // const collectionSetting = this.cas.collectionSetting;
      // console.warn(collectionSetting);
      if (this.templateType !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: { groupId: groupInfo[0], type: this.templateType }
        }).then((res) => {
          if (res.data.length !== 0) {
            res.data.forEach((element) => {
              if (`${element.id}` === groupInfo[3]) {
                this.cas.sendTemplate = `${element.content}&&${element.id}&&${element.type}`;
              }
            });
            if (groupInfo[3] === 'null') {
              this.cas.sendTemplate = `${res.data[0].content}&&${res.data[0].id}&&${res.data[0].type}`;
            }
            this.templateList = res.data;
          } else {
            this.templateList = [];
            this.cas.sendTemplate = '';
          }
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: { groupId: groupInfo[0], type: this.templateType }
        }).then((res) => {
          if (res.data.length !== 0) {
            res.data.forEach((element) => {
              if (`${element.id}` === groupInfo[3]) {
                this.cas.sendTemplate = `${element.content}&&${element.id}&&${element.type}`;
              }
            });
            if (groupInfo[3] === 'null') {
              this.cas.sendTemplate = `${res.data[0].content}&&${res.data[0].id}&&${res.data[0].type}`;
            }
            this.templateList = res.data;
          } else {
            this.templateList = [];
            this.cas.sendTemplate = '';
          }
        });
      }
    },
    templateTypeChange() {
      if (this.cas.group === '&&&&&&') {
        this.templateList = [];
        this.cas.sendTemplate = '';
        return;
      }
      const groupInfo = this.cas.group.split('&&');
      if (this.templateType !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: { groupId: groupInfo[0], type: this.templateType }
        }).then((res) => {
          if (res.data.length !== 0) {
            this.cas.sendTemplate = `${res.data[0].content}&&${res.data[0].id}&&${res.data[0].type}`;
            this.templateList = res.data;
          } else {
            this.templateList = [];
            this.cas.sendTemplate = '';
          }
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: { groupId: groupInfo[0], type: this.templateType }
        }).then((res) => {
          if (res.data.length !== 0) {
            this.cas.sendTemplate = `${res.data[0].content}&&${res.data[0].id}&&${res.data[0].type}`;
            this.templateList = res.data;
          } else {
            this.templateList = [];
            this.cas.sendTemplate = '';
          }
        });
      }
    },
    searchChange(command) {
      this.caseSearchBody.keyType = command.split(',')[0];
      this.caseSearchBody.label = command.split(',')[1];
    },
    caseSearch() {
      if (!this.caseSearchBody.keyStr) {
        return;
      }
      this.caseSearchBody.keys = this.caseSearchBody.keyStr.split(',');
      this.$ajax({
        method: 'POST',
        url: '/caseList/list',
        data: this.caseSearchBody
      }).then((res) => {
        if (res.data.totalRecords === 0) {
          this.$notify.success({
            title: '提示',
            message: '查找结果不存在'
          });
        } else if (res.data.totalRecords === 1) {
          const caseId = Base64.encode(res.data.list[0].id).trim();
          location.href = `/main/case/detail/${caseId}`;
        } else if (res.data.totalRecords > 1) {
          this.caseSearchBody.limit = 50;
          this.operateCache();
          location.href = '/main/case/caseList';
        }
      });
    },
    logout() {
      this.$confirm('您确定要退出吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 情况所有缓存数据
        sessionStorage.clear();
        this.loading = true;
        this.$ajax({
          prompt: true,
          method: 'POST',
          url: '/account/logout'
        }).then(() => {
          localStorage.removeItem('account');
          localStorage.removeItem('permissions');
          localStorage.removeItem('authorization');
          localStorage.removeItem('internationalVersionFlag');
          localStorage.removeItem('languageSelectOptions');
          localStorage.removeItem('languageSelect');
          setTimeout(() => {
            this.loading = false;
            this.$router.push({ 'path': '/' });
          }, 1000);
        });
      }).then(() => {
        localStorage.removeItem('account');
        localStorage.removeItem('permissions');
        localStorage.removeItem('authorization');
        localStorage.removeItem('internationalVersionFlag');
        localStorage.removeItem('languageSelectOptions');
        localStorage.removeItem('languageSelect');
        this.$router.push({ 'path': '/' });
      });
    },
    operateCache() {
      localStorage.removeItem('caseSearchCompanyId');
      localStorage.removeItem('caseSearchCache');
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(this.caseSearchBody);
      localStorage.setItem('caseSearchCache', caseSearchCache);
    },
    openMonitor() {
      window.open('/monitor/robotMonitor');
    },
    getMyExcelDataInfo(data, sheetName, fileName, fileSize) { // 案件详情
      if (sheetName === 'start') {
        this.readExcelProgressBar = true;
        this.isSelectExcel = true;
        this.upLoadRemindMsg = '文件解析中......';
        return;
      }
      this.fileName = fileName;
      if (sheetName === '案件基本信息') {
        // 校验上传excel--案件基本信息 是否合法
        this.checkCaseResult = this.checkSheet(data, sheetName);
        if (!this.checkCaseResult) {
          return;
        }
        this.caseCount = data.length;
        this.baseCaseInfo = JSON.stringify(data);
      }
      if (!this.checkCaseResult) {
        return;
      }
      if (sheetName === '详单电话') {
        // 校验上传excel--详单电话 是否合法
        this.contactCount = data.length;
        if (data.length > 0) {
          this.checkContactResult = this.checkSheet(data, sheetName);
          this.contactInfo = JSON.stringify(data);
        } else {
          this.checkContactResult = true;
          this.contactInfo = [];
        }
      }
      if (this.checkCaseResult && this.checkContactResult) {
        if (!this.formatData()) {
          this.removeExcel();
          return;
        }
        if (this.fileName.length > 20) {
          this.fileName = `${this.fileName.substring(0, 3)}*****${this.fileName.substring(this.fileName.length - 8, this.fileName.length)}`;
        }
        this.upLoadRemindMsg = `${this.fileName}(案件数:${this.caseCount};联系人数:${this.contactCount};文件约:${fileSize}M)`;
      }
    },
    checkSheet(caseList, sheetName) {
      const keys = Object.keys(caseList[0]);
      if (sheetName === '案件基本信息') {
        for (let i = 0; i < keys.length; i++) {
          if (this.caseSheetKeys.indexOf(keys[i]) < 0) {
            this.$message({
              type: 'error',
              message: `您上传的《${sheetName}》列名不正确（${keys[i]}）!`
            });
            this.removeExcel();
            return false;
          }
        }
      } else {
        for (let i = 0; i < keys.length; i++) {
          if (this.contactSheetKeys.indexOf(keys[i]) < 0) {
            this.$message({
              type: 'error',
              message: `您上传的${sheetName}列名不正确（${keys[i]}）!`
            });
            return false;
          }
        }
      }
      return true;
    },
    closeProBar1() {
      this.readExcelProgressBar = false;
      if (this.checkCaseResult && this.checkContactResult) {
        this.isSelectExcel = true;
      }
    },
    removeExcel() { // 移除选中的Excel
      this.initUploadInfo();
    },
    initUploadInfo() {
      this.caseCount = 0;
      this.contactCount = 0;
      this.upLoadRemindMsg = '';
      this.isSelectExcel = false;
      this.baseCaseInfo = '';
      this.contactInfo = '';
      this.caseBaseInfoList = [];
      this.caseList = [];
      this.contactList = [];
      this.readExcelProgressBar = false;
      this.isLoading = false;
      this.resultOfImportCase = null;
      clearInterval(this.timing);
      clearInterval(this.conTiming);
      this.loadNum = 0;
    },
    newUploadData() {
      if (this.isSelectExcel === false) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      if (this.caseCount === 0) {
        this.$message({
          type: 'error',
          message: '上传的文件中不包含任何案件，请检查!'
        });
        return;
      }
      // if (this.contactCount === 0) {
      //   this.$message({
      //     type: 'error',
      //     message: '上传的文件中不包含任何联系人，请检查!'
      //   });
      //   return;
      // }
      // 检查并封装导入设置信息
      const caseSettingVo = {};
      caseSettingVo.sendType = this.cas.collectionSetting === 'msg' ? 0 : 1;
      caseSettingVo.planDays = this.days;
      caseSettingVo.planDiscount = this.cas.discount;
      caseSettingVo.templateType = this.templateType;
      if (this.cas.group !== '&&&&&&') {
        const groupInfo = this.cas.group.split('&&');
        caseSettingVo.groupId = groupInfo[0];
        caseSettingVo.groupType = groupInfo[1];
        if (groupInfo[1] != null && groupInfo[1] !== undefined && groupInfo[1] !== '' && groupInfo[1] !== 2) {
          caseSettingVo.groupSendWay = groupInfo[2];
          caseSettingVo.templateId = groupInfo[3];
        } else {
          caseSettingVo.groupSendWay = '';
          caseSettingVo.templateId = '';
        }
      } else { // 不指定策略组
        caseSettingVo.groupId = '';
        caseSettingVo.groupType = '';
        caseSettingVo.groupSendWay = '';
        caseSettingVo.templateId = '';
      }
      if (this.cas.notice) {
        console.warn(this.cas.notice);
        if (this.cas.sendTemplate) {
          const sendTemplate = this.cas.sendTemplate.split('&&');
          caseSettingVo.templateId = sendTemplate[1];
          // caseSettingVo.groupSendWay = sendTemplate[2];
        }
      }
      caseSettingVo.isSendNow = this.cas.notice ? 1 : 0;
      caseSettingVo.isSendAllSelf = this.cas.notice ? 1 : 0; // 是否立即发送给所有本人
      caseSettingVo.isSendAllDirect = 0; // 是否立即发送给所有直系
      caseSettingVo.isSendAllNoDirect = 0; // 是否立即发送给所有的非直系

      caseSettingVo.isSendObjectSelf = 1; // 可作业本人
      caseSettingVo.isSendObjectDirect = 0; // 可作业直系
      caseSettingVo.isSendObjectNoDirect = 0;// 可作业非直系
      caseSettingVo.isSendObjectLoseRepair = 0;// 可作业失联修复
      // 发送对象
      const targetss = this.cas.target;
      for (let i = 0; i < targetss.length; i++) {
        if (targetss[i] === '直系') {
          caseSettingVo.isSendObjectDirect = 1;
        }
        if (targetss[i] === '非直系') {
          caseSettingVo.isSendObjectNoDirect = 1;
        }
        if (targetss[i] === '失联修复') {
          caseSettingVo.isSendObjectLoseRepair = 1;
        }
      }

      // this.formatData();
      if (this.isSelectExcel === false) {
        return;
      }
      const paramterData = {};
      paramterData.caseBaseInfoList = this.caseBaseInfoList;
      paramterData.caseSettingVo = caseSettingVo;
      this.getBatchNoAndUpload(paramterData);
    },
    formatData() { // 转换数据格式
      const hash = {};
      this.caseBaseInfoList = [];
      const caseInfoJson = JSON.parse(this.baseCaseInfo);
      for (let i = 0; i < caseInfoJson.length; i++) {
        const newCaseInfoVo = {};
        const vo = caseInfoJson[i];
        newCaseInfoVo.batchNo = '123456';
        if (vo.进件号 === undefined || vo.进件号 === null) {
          this.$message({
            type: 'error',
            message: '进件号不能为空,请检查后重新上传'
          });
          this.removeExcel();
          return;
        }
        newCaseInfoVo.aCaseId = vo.进件号 === undefined ? null : vo.进件号;
        newCaseInfoVo.name = vo.姓名 === undefined ? null : vo.姓名;
        newCaseInfoVo.age = vo.年龄 === undefined ? null : vo.年龄;
        newCaseInfoVo.gender = vo.性别 === undefined ? null : vo.性别;
        newCaseInfoVo.idNo = vo.身份证号码 === undefined ? null : vo.身份证号码;
        newCaseInfoVo.address = vo.案件地区 === undefined ? null : vo.案件地区;
        newCaseInfoVo.householdRegister = vo.户籍地址 === undefined ? null : vo.户籍地址;
        newCaseInfoVo.companyAddress = vo.公司地址 === undefined ? null : vo.公司地址;
        newCaseInfoVo.permanentAddress = vo.常住地址 === undefined ? null : vo.常住地址;
        newCaseInfoVo.mobile = vo.手机号码 === undefined ? null : vo.手机号码;
        newCaseInfoVo.loanInstitutions = vo.贷款机构 === undefined ? null : vo.贷款机构;
        newCaseInfoVo.dateOfLoan = vo.放款日期 === undefined ? null : new Date(vo.放款日期).getTime();
        newCaseInfoVo.loanPeriod = vo.借款期数 === undefined ? null : vo.借款期数;
        newCaseInfoVo.amount = vo.签约金额 === undefined ? null : vo.签约金额;
        newCaseInfoVo.loanAmount = vo.放款金额 === undefined ? null : vo.放款金额;
        newCaseInfoVo.monthlyRepay = vo.月还款额 === undefined ? null : vo.月还款额;
        newCaseInfoVo.residualPrincipal = vo.剩余本金 === undefined ? null : vo.剩余本金;
        newCaseInfoVo.totalPenalty = vo.罚滞总额 === undefined ? null : vo.罚滞总额;
        newCaseInfoVo.overdueAmount = vo.逾期总额 === undefined ? null : vo.逾期总额;
        newCaseInfoVo.overdueStatus = vo.逾期状态 === undefined ? null : vo.逾期状态;
        newCaseInfoVo.overdueTime = vo.逾期次数 === undefined ? null : vo.逾期次数;
        newCaseInfoVo.lastRepayDate = vo.最近一次还款时间 === undefined ? null : new Date(vo.最近一次还款时间).getTime();
        newCaseInfoVo.lastRepayAmount = vo.最近一次还款金额 === undefined ? null : vo.最近一次还款金额;
        newCaseInfoVo.loanType = vo.贷款类型 === undefined ? null : vo.贷款类型;
        newCaseInfoVo.overdueDates = vo.逾期天数 === undefined ? null : vo.逾期天数;
        newCaseInfoVo.delegateAmount = vo.委托金额 === undefined ? null : vo.委托金额;
        newCaseInfoVo.collectMethod = vo.催收类型 === undefined ? null : vo.催收类型;
        newCaseInfoVo.repayedPeriods = vo.已还期数 === undefined ? null : vo.已还期数;
        newCaseInfoVo.statementDate = vo.账单日 === undefined ? null : vo.账单日;
        newCaseInfoVo.loanProductName = vo.借款产品名称 === undefined ? null : vo.借款产品名称;
        newCaseInfoVo.boundBankCard = vo.客户绑定划扣银行卡 === undefined ? null : vo.客户绑定划扣银行卡;
        newCaseInfoVo.personCompany = vo.客户所属公司 === undefined ? null : vo.客户所属公司;
        newCaseInfoVo.commissionRateA = vo['佣金费率（甲方，eg:20即为20%，填写时请不要带%）'];
        newCaseInfoVo.startTime = vo.起委时间 === undefined ? null : new Date(vo.起委时间).getTime();
        newCaseInfoVo.endTime = vo.结委时间 === undefined ? null : new Date(vo.结委时间).getTime();
        newCaseInfoVo.educateLevel = vo.教育程度 === undefined ? null : vo.教育程度;
        newCaseInfoVo.entryDate = vo.入职时间 === undefined ? null : new Date(vo.入职时间).getTime();
        newCaseInfoVo.maritalStatus = vo.婚姻状况 === undefined ? null : vo.婚姻状况;
        newCaseInfoVo.position = vo.职位 === undefined ? null : vo.职位;
        newCaseInfoVo.workingLife = vo.工作年限 === undefined ? null : vo.工作年限;
        newCaseInfoVo.house = vo.房产状况 === undefined ? null : vo.房产状况;
        newCaseInfoVo.children = vo.子女状况 === undefined ? null : vo.子女状况;

        newCaseInfoVo.msgTitle = vo.短信抬头 === undefined ? null : vo.短信抬头;
        newCaseInfoVo.param1 = vo.参数1 === undefined ? null : vo.参数1;
        newCaseInfoVo.param2 = vo.参数2 === undefined ? null : vo.参数2;
        newCaseInfoVo.param3 = vo.参数3 === undefined ? null : vo.参数3;
        newCaseInfoVo.param4 = vo.参数4 === undefined ? null : vo.参数4;
        newCaseInfoVo.param5 = vo.参数5 === undefined ? null : vo.参数5;
        newCaseInfoVo.param6 = vo.参数6 === undefined ? null : vo.参数6;
        newCaseInfoVo.param7 = vo.参数7 === undefined ? null : vo.参数7;
        newCaseInfoVo.param8 = vo.参数8 === undefined ? null : vo.参数8;
        newCaseInfoVo.param9 = vo.参数9 === undefined ? null : vo.参数9;
        newCaseInfoVo.param10 = vo.参数10 === undefined ? null : vo.参数10;
        newCaseInfoVo.param11 = vo.参数11 === undefined ? null : vo.参数11;
        newCaseInfoVo.param12 = vo.参数12 === undefined ? null : vo.参数12;
        newCaseInfoVo.param13 = vo.参数13 === undefined ? null : vo.参数13;
        newCaseInfoVo.param14 = vo.参数14 === undefined ? null : vo.参数14;
        newCaseInfoVo.param15 = vo.参数15 === undefined ? null : vo.参数15;
        newCaseInfoVo.param16 = vo.参数16 === undefined ? null : vo.参数16;
        newCaseInfoVo.param17 = vo.参数17 === undefined ? null : vo.参数17;
        newCaseInfoVo.param18 = vo.参数18 === undefined ? null : vo.参数18;
        newCaseInfoVo.param19 = vo.参数19 === undefined ? null : vo.参数19;
        newCaseInfoVo.param20 = vo.参数20 === undefined ? null : vo.参数20;
        newCaseInfoVo.param21 = vo.参数21 === undefined ? null : vo.参数21;
        newCaseInfoVo.param22 = vo.参数22 === undefined ? null : vo.参数22;
        newCaseInfoVo.param23 = vo.参数23 === undefined ? null : vo.参数23;
        newCaseInfoVo.param24 = vo.参数24 === undefined ? null : vo.参数24;
        newCaseInfoVo.param25 = vo.参数25 === undefined ? null : vo.参数25;
        newCaseInfoVo.param26 = vo.参数26 === undefined ? null : vo.参数26;
        newCaseInfoVo.param27 = vo.参数27 === undefined ? null : vo.参数27;
        newCaseInfoVo.param28 = vo.参数28 === undefined ? null : vo.参数28;
        newCaseInfoVo.param29 = vo.参数29 === undefined ? null : vo.参数29;
        newCaseInfoVo.param30 = vo.参数30 === undefined ? null : vo.参数30;

        this.caseList[i] = newCaseInfoVo;
        if (hash[newCaseInfoVo.aCaseId]) {
          this.$message({
            type: 'error',
            message: `【案件基本信息】进件号：${newCaseInfoVo.aCaseId}存在重复，请核实！！！`
          });
          return;
        }
        hash[newCaseInfoVo.aCaseId] = true;
      }
      this.newCaseInfoVo = '';
      this.contactList = [];
      if (this.contactInfo.length !== 0) {
        const contactInfoJson = JSON.parse(this.contactInfo);
        // 格式化联系人信息
        for (let j = 0; j < contactInfoJson.length; j++) {
          const newContacetVo = {};
          const cvo = contactInfoJson[j];
          if (cvo.进件号 === undefined || cvo.进件号 === null) {
            this.$message({
              type: 'error',
              message: '进件号不能为空,请检查后重新上传'
            });
            this.removeExcel();
            return;
          }
          newContacetVo.batchNO = '123456';
          newContacetVo.aCaseId = cvo.进件号;
          newContacetVo.name = cvo.姓名;
          newContacetVo.type = cvo.类别;
          newContacetVo.detail = cvo.手机号码;
          newContacetVo.remark = cvo['备注（关系）'];
          newContacetVo.detailSrc = cvo.来源;
          this.contactList[j] = newContacetVo;
        }
      }
      // 校验联系人是否可以全部匹配到案件
      for (let c = 0; c < this.contactList.length; c++) {
        this.contactEntity = this.contactList[c];
        for (let d = 0; d < this.caseList.length; d++) {
          if (this.caseList[d].aCaseId.toString() === this.contactList[c].aCaseId.toString()) {
            this.checkContactDate = true;
          }
        }
        if (!this.checkContactDate) {
          this.$message({
            type: 'error',
            message: `进件号为${this.contactEntity.aCaseId}的联系人未能匹配到案件！！`
          });
          this.removeExcel();
          return;
        }
      }
      this.newContacetVo = '';
      this.caseBaseInfoList = [];
      // 循环遍历匹配案件---联系人
      for (let a = 0; a < this.caseList.length; a++) {
        const caseBaseInfoDTO = {};
        caseBaseInfoDTO.aCaseId = this.caseList[a].aCaseId;
        caseBaseInfoDTO.caseVo = this.caseList[a];
        const contactVoList = [];
        for (let b = 0; b < this.contactList.length; b++) {
          if (this.caseList[a].aCaseId.toString() === this.contactList[b].aCaseId.toString()) {
            contactVoList.push(this.contactList[b]);
          }
        }
        caseBaseInfoDTO.contactVoList = contactVoList;
        this.caseBaseInfoList.push(caseBaseInfoDTO);
      }
      // eslint-disable-next-line
      return true;
    },
    checkRepeat(arr) {
      const hash = {};
      // eslint-disable-next-line
      for (const i in arr) {
        if (hash[arr[i]]) {
          this.$message({
            type: 'error',
            message: `【案件基本信息】进件号：${arr[i]}存在重复，请核实！！！`
          });
          return true;
        }
        hash[arr[i]] = true;
      }
      return false;
    },
    startLoading() {
      let interval = 50;
      if (this.caseCount > 200 && this.caseCount <= 500) {
        interval = 100;
      } else if (this.caseCount > 500 && this.caseCount < 1000) {
        interval = 200;
      } else {
        interval = 300;
      }
      this.timing = setInterval(() => {
        if (localStorage.getItem('startTiming') === 'stop') {
          // eslint-disable-next-line
          clearInterval(this.timing);
          return;
        }
        if (this.loadNum !== undefined && this.loadNum <= 90) {
          this.$refs.loading.setLoadingWidthTimer(this.loadNum);
          this.loadNum += 1;
        }
      }, interval);
      localStorage.setItem('startTimingNum', this.timing);
      this.$refs.loading.initPoints();
    },
    continueLoading() {
      localStorage.setItem('continueTiming', 'start');
      this.conTiming = setInterval(() => {
        if (localStorage.getItem('continueTiming') === 'stop') {
          // eslint-disable-next-line
          clearInterval(this.conTiming);
          // this.timing = null;
          this.$refs.loading.closePoinst();
          return;
        }
        if (this.loadNum <= 100) {
          this.$refs.loading.setLoadingWidthTimer(this.loadNum);
          this.loadNum += 1;
        } else {
          clearInterval(this.conTiming);
          this.timing = null;
          this.$refs.loading.closePoinst();
        }
      }, 50);
      localStorage.setItem('continueTimingNum', this.conTiming);
    },
    getBatchNoAndUpload(paramterData) { // 导入时获取batchNo
      this.importDialogVisible = false;
      this.isLoading = true;
      localStorage.setItem('startTiming', 'start');
      setTimeout(this.startLoading, 1000);
      this.$ajax({
        url: '/robotCaseImport/getBatchNoWhenImportCase'
      }).then((res) => {
        this.token = res.data.token;
        this.batchToken = res.data.batchToken;
        this.batchNo = res.data.batchNo;
        this.serverUrl = res.data.serverUrl;
        paramterData.userName = '';
        paramterData.password = '';
        paramterData.ipAddress = '255.255.255.255';
        paramterData.batchToken = this.batchToken;
        paramterData.batchNo = this.batchNo;
        paramterData.token = this.token;
        paramterData.importUpdate = this.cas.importUpdate;
        this.importCaseInfoExcel(paramterData);
      });
    },
    importCaseInfoExcel(paramterData) {
      this.$ajax({
        url: '/robotCaseImport/importCaseInfoExcel',
        data: paramterData
      }).then((res2) => {
        if (res2.code === 200) {
          this.resultOfImportCase = res2.data;
          clearInterval(this.timing);
          this.continueLoading();
        } else {
          // this.$message({
          //   type: 'error',
          //   message: res2.msg
          // });
          // this.$notify.error({
          //   title: '提示',
          //   dangerouslyUseHTMLString: true,
          //   message: res2.msg
          // });
          this.closeTiming();
          this.removeExcel();
          this.isLoading = false;
          this.importDialogVisible = false;
          this.$refs.copyTemp.showErrorInfo(res2.msg);
          // clearInterval(this.timing);
        }
      });
    },
    closeTiming() {
      localStorage.setItem('startTiming', 'stop');
      localStorage.setItem('continueTiming', 'stop');
    },
    loadFinish() { // 录入进度条加载完成
      this.importWriteCache([this.resultOfImportCase]);
      if (this.$route.path === '/main/case/caseList') {
        this.reload();
      } else {
        this.$router.push({ path: '/main/case/caseList' });
      }
      clearInterval(this.conTiming);
      this.removeExcel();
    }
  },
  beforeDestroy() {
    clearInterval(this.timing);
    clearInterval(this.conTiming);
  }
};
</script>
<style lang="less" scoped>
@import '../../assets/style/variable.less';

.el-container {
  height: 100%;

  .el-aside {
    background: #242a3c;
    transition: all .3s ease;

    .nav-header {
      box-sizing: border-box;
      height: 60px;
      padding: 5px;
      text-align: center;
      background-image: linear-gradient(to bottom, #263256, #242f4b, #2b3248);
      // background: #394046;
    }

    &.uncollapse {
      .el-menu-item, .el-submenu__title {
        .fa {
          margin-right: 5px;
        }
      }

      .el-menu-item.is-active {
        background-color: #4D7CFE !important;
      }

      .el-menu--inline {
        .el-menu-item {
          padding-left: 52px !important;
          height: 42px;
          line-height: 42px;
          font-size: 13px;
          color: #fff !important;
          background-color: #181d2b !important;

          &.is-active {
            color: #fff !important;
            background-color: #4D7CFE !important;

            &:hover {
              color: #fff !important;
            }
          }

          &:hover {
            color: #fff !important;
          }
        }
      }
    }
  }

  .el-main {
    padding: 0;

    .el-container {
      .el-header {
          padding-left: 0;
          color: #ece2e2;
          box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
          background-image: linear-gradient(to bottom, #263256, #242f4b, #2b3248);
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: space-between;

        .menu-collapse {
          box-sizing: border-box;
          display: inline-block;
          padding: 15px 25px;
          height: 60px;
          font-size: 1.28rem;
          // color: rgb(84, 92, 100);
          color: #f2f2f2;

          svg {
            vertical-align: middle;
          }

          &:hover {
            background: #4D7CFE;
          }
        }

        .header-center {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .header-options {
          display: flex;
          height: 60px;
          line-height: 60px;

          & > div {
            flex: 1 0 auto;
            position: relative;
            padding: 0 15px;

            .el-dropdown-link {
              display: inline-block;
              cursor: pointer;
            }

            &.search-wrapper {
              margin: 0 30px;

              .icon-btn {
                cursor: pointer;
              }

              .search-input {
                margin: 0 10px;
                height: 30px;
                font-size: 1rem;
                border: none;
                border-bottom: 1px solid #dcdfe6;

                &:focus {
                  outline: none;
                  border-bottom-color: @primary;
                }
              }
            }
          }

          .upload-case {
            height: 34px;
            margin-top: 13px;
          }

          .avatar {
            margin-right: 5px;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
      }

      .el-main {
        background: #f0f2f5;
      }

      .current-time {
        font-size: 14px;
        color: #ffffff;
        margin: 0 12px;
        line-height: 60px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/main/root.vue